import React from "react";

/**
 * @component CloseCircleIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <CloseCircleIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CloseCircleIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="CloseCircleIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2a8 8 0 100 16 8 8 0 000-16zM9.194 7.79l2.805 2.806 2.807-2.805a.992.992 0 111.403 1.403l-2.806 2.805 2.806 2.807a.992.992 0 11-1.403 1.403L12 13.403 9.194 16.21a.992.992 0 11-1.403-1.403L10.596 12 7.79 9.194A.992.992 0 119.194 7.79z"
      />
    </svg>
  )
);
CloseCircleIcon.displayName = "CloseCircleIcon";
export default CloseCircleIcon;
